export default __webpack_public_path__ + "static/media/logo.b87a157f.svg";